module.exports = __webpack_public_path__ + "img/icon-course.691c567f.png";